module.exports = __webpack_public_path__ + "r-v3/img/ico_chat_send_possible.f9106259.svg";